import React from 'react'
import { Router, Switch, Redirect } from 'react-router-dom'
import { history } from './helpers/history'
import Homepage from './pages/Homepage'
import NotificationsContainer from './components/NotificationsContainer'
import { Route } from 'react-router-dom/cjs/react-router-dom.min'

const AppRouter = () => {

  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/">
          <Homepage />
        </Route>
        <Redirect from="*" to="/" />
      </Switch>
      <NotificationsContainer />
    </Router>
  )
}

export default AppRouter
